import { LandLineListInterface } from '../../models/land-line-list.interface';

export interface LandLineListInterfaceState {
  list: Array<LandLineListInterface>;
}

export const initialLandLineListState: LandLineListInterfaceState = {
  list: null
};
